import Button from "./Button";
import LoadingButton from "./LoadingButton";
import SecondaryButton from "./SecondaryButton";
import ToClassicButton from "./ToClassicButton";

export { LoadingButton, SecondaryButton, ToClassicButton };
export default Button;
